module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "password",
      "data-vv-rules": 'required',
      "data-vv-name": "old_password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.securityPreferencesOldPassword'),
      "errorText": _vm.errors.first('old_password'),
      "label": _vm.$t('message.securityPreferencesOldPassword'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.old_password),
      callback: function($$v) {
        _vm.$set(_vm.model, "old_password", $$v)
      },
      expression: "model.old_password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": _vm.model.visible ? 'text' : 'password',
      "data-vv-rules": 'required|min: 10|strong_password_regex',
      "data-vv-name": "new_password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.securityPreferencesDesiredPassword'),
      "errorText": _vm.errors.first('new_password'),
      "label": _vm.$t('message.securityPreferencesDesiredPassword'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.new_password),
      callback: function($$v) {
        _vm.$set(_vm.model, "new_password", $$v)
      },
      expression: "model.new_password"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.model.visible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.model.visible = !_vm.model.visible
      }
    }
  })], 1), _vm._v(" "), _c('password-strength-validation', {
    attrs: {
      "password": _vm.model.new_password
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') + '...' : _vm.$t('message.updateText'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('email-update')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbe893d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Security.vue
// module id = 3321
// module chunks = 1